<div fxFlex fxLayout="column" [formGroup]="form_address">
    <lgd-text controlName="attention" label="Attention">
    </lgd-text>

    <lgd-text controlName="line1" label="Line 1">
    </lgd-text>

    <lgd-text controlName="line2" label="Line 2">
    </lgd-text>

    <div fxLayout="row" fxLayoutAlign="space-between center">
        <lgd-text fxFlex="50" controlName="city" label="City">
        </lgd-text>

        <lgd-text fxFlex="15" controlName="state" label="State">
        </lgd-text>

        <lgd-text fxFlex="30" controlName="postalCode" label="Postal Code">
        </lgd-text>
    </div>
</div>
